import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import IconDown from '@assets/images/icons/arr_down.svg'
import IconRight from '@assets/images/icons/arr_right.svg'
import IconAdd from '@assets/images/icons/add_folder.svg'
import IconCheck from '@assets/images/icons/check_medium.svg'

import clsx from 'clsx'

import { SquareIconButton } from '@/modules/base/components/buttons'
import lang from '@/lang'
import { useSelector } from 'react-redux'
import { createFolder } from '@/redux/ducks/lists/requests/documentList'
import { canWriteFolder } from '@/modules/file/permissions'

const useStyles = makeStyles((theme) => ({
  input: {
    border: theme.border,
    borderRadius: 4,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    '&:focus': {
      border: theme.border,
      outline: 'none',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: ({ node: { isRoot } }) => isRoot ? 0 : 10,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: theme.backgroundColor,
    },
  },
  button: {
    border: 'none',
    backgroundColor: 'transparent !important',
    '& svg': {
      fill: theme.lightGrey,
    },
  },
  createButton: {
    borderLeft: 'none',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    backgroundColor: `${theme.white} !important`,
    '& svg': {
      fill: theme.green,
    },
  },
  spacer: {
    height: 25,
    width: 33,
  },
  name: {
    cursor: 'pointer',
    marginRight: 10,
  },
  selected: {
    color: theme.primary,
  },
  create: {
    display: 'flex',
  },
  createLoader: {
    minWidth: 32,
    height: 32,
    borderBottomLeftRadius: 0,
    borderTopLeftRadius: 0,
  },
}))

const FolderSelectTree = (props) => {
  const classes = useStyles(props)
  const { options: { filter }, folders } = useSelector(state => state.document.list)

  const { node, onClick } = props

  const [open, setOpen] = useState(props?.path?.includes(node?.folderPath))
  const [childOpen, setChildOpen] = useState(0)
  const [loading, setLoading] = useState(false)
  const isSelected = node.folderPath?.slice(0, -1) === props.path
  const canCreate = canWriteFolder(node?.parent ?? node)

  const onChildOpen = (count) => {
    setChildOpen(childOpen + count)
  }

  const children = node.create
    ? []
    : childOpen || node.isSystemFolder
      ? node.children
      : [...node.children, { name: '', create: true, parent: node, children: [] }]

  useEffect(() => {
    if (open) {
      props.onOpen(-1)
    }
  }, [])

  const openTree = (e) => {
    e.stopPropagation()
    props.onOpen(!open ? 1 : -1)
    setChildOpen(0)
    setOpen(!open)
  }
  useEffect(() => {
    if (open) {
      props.onOpen(-1)
    }
  }, [])

  const button = children.length && !node.isRoot
    ? (<SquareIconButton customClass={classes.button}onClick={openTree} icon={open ? IconDown : IconRight} />)
    : node.create || node.isRoot
      ? <SquareIconButton customClass={classes.button} icon={IconAdd} />
      : <div className={classes.spacer}></div>

  const [value, setValue] = useState('')

  const onKeyUp = ({ key }) => {
    if (!canCreate) return
    if (key === 'Enter') {
      setLoading(true)
      createFolder(value, node.parent, filter, folders).finally(() => setLoading(false))
    }
  }

  const createElement = (<span className={classes.create}>
    <input disabled={loading || !canCreate} className={classes.input} placeholder={lang.documents.addFolder} onChange={(e) => setValue(e.target.value)} onKeyUp={onKeyUp} />
    <SquareIconButton disabled={!value || loading || !canCreate} isLoading={loading} loaderClass={classes.createLoader} icon={IconCheck} className={classes.createButton} onClick={() => onKeyUp({ key: 'Enter' })} />
  </span>)

  return (
    <div className={clsx(classes.content)}>
      {!node.isRoot && <span className={classes.row} onClick={() => { !node.create && onClick(node) }}>
        {button}
        {
          node.create
            ? createElement
            : <span className={clsx(classes.name, { [classes.selected]: isSelected })}>{node.name}</span>
        }
      </span>}
      {(open || node.isRoot) && <div>{children.map((child, i) => <FolderSelectTree key={`${child.name}#${i}`} {...props} node={child} onClick={onClick} onOpen={onChildOpen} />)}</div>}
    </div>
  )
}

FolderSelectTree.propTypes = {
  onClick: PropTypes.func,
  node: PropTypes.object,
  currentFolder: PropTypes.object,
}

FolderSelectTree.defaultProps = {
  onOpen: () => {},
}

export default FolderSelectTree
